module.exports = __webpack_public_path__ + "static/media/help.63d0f3e0.svg";